<template>

  <div class="bg-gradient-primary wrapper">
      <div class="container">

    <!-- Outer Row -->
        <div class="row justify-content-center">

          <div class="col-xl-10 col-lg-12 col-md-9">

            <div class="card o-hidden border-0 shadow-lg my-5">
              <div class="card-body p-0">
                <!-- Nested Row within Card Body -->
                <div class="row justify-content-center">
                  <div class="col-lg-8">
                    <div class="p-5">
                      <div class="text-center">
                        <h1 class="h4 text-gray-900 mb-4">Admin Login</h1>
                      </div>
                      <form class="user" @submit.prevent="login">
                        <div class="form-group">
                          <input type="email" class="form-control form-control-user" i
                          v-model="email" d="exampleInputEmail" aria-describedby="emailHelp"
                          placeholder="Enter Email Address..." required>
                        </div>
                        <div class="form-group">
                          <input type="password" class="form-control form-control-user" 
                            v-model="password" id="exampleInputPassword" placeholder="Password" required>
                        </div>
                        <p class="text-danger text-center">{{message}}</p>
                        <button type="submit" class="btn btn-primary btn-user btn-block">
                          Login
                          <div class="spinner-grow" role="status" v-if="loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </button>
                        <hr>
                      </form>
                      
                      <div class="text-center">
                        <a class="small" href="forgot-password.html">Forgot Password?</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
  </div>
  </div>
</template>

<script>
import url from '../URL'
export default {
    data(){
        return {
            email:'',
            password:'',
            message:'',
            loading:false
        }

    },
    methods: {
       async login(e) {
           e.preventDefault()
            this.loading = true
            this.message = ''
            try {
            const response = await this.$http.post(`${this.apiurl}/api/actioncommons/admin/login`,
                     {
                    "email" : this.email,
                    "password" : this.password
                })

                 if(response.status === 200) {
                     localStorage.setItem('adminToken', response.data.token)
                     this.loading = false;
                     this.$router.push('/admin/home')
                 }
             
            } catch( err) {
                   /* if(err.response.status === 400) {
                        this.message = "Incorrect Email and Password."
                        this.loading = false

                    } */
            
            
        }
        },
        },
    computed: {
      apiurl() {
        return url()
    } 
    }
    
}
</script>

<style scoped>
 .btn-user {
    font-size: 0.8rem;
    border-radius: 10rem;
    padding: 0.75rem 1rem;
  }
  .wrapper{
    height: 100vh;
  }
</style>